var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"af-share"},[_c('div',[_vm._v("Tipsa en vän om Jobskills")]),_vm._v(" "),_c('div',{staticClass:"af-share__options"},_vm._l((_vm.shareOptions),function(option){return _c('a',{key:option.iconType,staticClass:"af-share__link",attrs:{"href":option.link}},[_c('icon',{attrs:{"fill":"#fff","type":option.iconType}})],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01f6beff","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Share.vue
// module id = 579
// module chunks = 1